// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"cf001cef2eab544526e7","873":"bb949808ce57db015c7f"}[chunkId] + ".js";
};